export const appColors = {
  primary: 'rgba(4, 6, 94, 1)',
  secondary: 'rgba(255, 191, 0, 1)',
};
